/** Steps around the outline: smooth at the largest icon size. */
const STEPS = 96
/** The superellipse exponent: 5 is close to iOS's continuous corners. */
const EXPONENT = 5

/**
 * The app icon's outline in a 100 × 100 box: the superellipse |x|⁵ + |y|⁵ = 1, as a
 * polygon fine enough to read as a curve. Shared by every icon, so they all match.
 */
export const SQUIRCLE_PATH = buildSquircle()

function buildSquircle(): string {
  const points: string[] = []
  for (let i = 0; i < STEPS; i++) {
    const angle = (i / STEPS) * Math.PI * 2
    const cos = Math.cos(angle)
    const sin = Math.sin(angle)
    const x = 50 + 50 * Math.sign(cos) * Math.abs(cos) ** (2 / EXPONENT)
    const y = 50 + 50 * Math.sign(sin) * Math.abs(sin) ** (2 / EXPONENT)
    points.push(`${x.toFixed(2)} ${y.toFixed(2)}`)
  }
  return `M${points.join('L')}Z`
}
